var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64853 1.16108C10.0076 0.802108 10.4946 0.600492 11.0024 0.600586C11.5101 0.60068 11.9971 0.802476 12.356 1.16158C12.715 1.52069 12.9166 2.00769 12.9165 2.51544C12.9164 3.0232 12.7146 3.51013 12.3555 3.8691L11.6225 4.6011L8.91352 1.89509L9.64753 1.16108H9.64853ZM8.20852 2.60209L2.25248 8.55613C2.07169 8.73705 1.93544 8.95752 1.85448 9.20013L0.940471 11.9432C0.911272 12.0312 0.907127 12.1256 0.928497 12.2158C0.949868 12.306 0.995913 12.3886 1.06149 12.4541C1.12706 12.5197 1.20958 12.5658 1.29982 12.5871C1.39005 12.6085 1.48446 12.6044 1.57247 12.5752L4.31549 11.6611C4.55849 11.5811 4.7785 11.4441 4.9595 11.2631L10.9155 5.30911L8.20752 2.60209H8.20852Z",
    fill: "#F6F6F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit_icon.fa702abe93d76bbb73db8265aa0b1d7a.svg";
export { ForwardRef as ReactComponent };